var React = require('react');

function SelectArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.48 3.16h11.04L7 10.84z"}));
}

SelectArrow.defaultProps = {"id":"Layer_1","viewBox":"0 0 14 14"};

module.exports = SelectArrow;

SelectArrow.default = SelectArrow;
